import { useEffect } from 'react';
import { QUERY_PARAMS } from '../../../constants';
import { EventType, useAnalytics } from '../../hooks/analytics';

export const useEsiaReturnAnalytic = (stepName: string) => {
    const { pushEvent } = useAnalytics();

    useEffect(() => {
        const url = new URL(location.href);
        const isFromEsia = url.searchParams.get(QUERY_PARAMS.ESIA);

        if (isFromEsia) {
            url.searchParams.delete(QUERY_PARAMS.ESIA);
            window.history.replaceState(null, document.title, url.toString());

            pushEvent({
                event: EventType.mainEvent,
                eventAction: 'Возврат из ЕСИА',
                eventLabel: stepName,
            });
        }
    }, []);
};
